<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <modal-subscription-detail :callCheckRequest="callCheckRequest"/>
    <modal-password subtitle-modal="Forneça a senha para continuar" title-modal="Editar fatura"
                    :run-function="validateEditInvoice"/>
    <modal-default modal-title="Detalhes da fatura" modal-id="editInvoice" @modal-closed="cleanModal">
      <template>
        <div class="col-md-12">
          <label>ID da empresa:</label>
          <p class="invoice-text">{{ dataSendInvoice.companyId }}</p>
        </div>
        <div class="col-md-12">
          <label>ID da fatura:</label>
          <p class="invoice-text">{{ dataSendInvoice.id }}</p>
        </div>
        <input-select col="12" :options="trueOrFalse" label="Nota gerada:" :value-selected="true"
                      :content-value-selected="dataSendInvoice.invoiceGenerated"
                      @contentValueSelected="value => dataSendInvoice.invoiceGenerated = value"/>
        <div v-if="dataSendInvoice.invoiceGenerated === true">
          <input-text col="12" type="text" placeholder="Digite aqui..." label="Link da fatura:" :is-required="true"
                      :value-default="dataSendInvoice.uri"
                      :error-validate="validateError"
                      :input-error="invoiceGenerateError" :font-error="true"
                      @contentText="value => dataSendInvoice.uri = value"/>
        </div>
        <input-text v-if="dataSendInvoice.id" col="12" type="number" placeholder="Digite aqui..."
                    label="Número da fatura:"
                    :value-default="dataSendInvoice.rpSn"
                    @contentText="value => dataSendInvoice.rpSn = value"/>
        <btn-custom label="Enviar" which-side="right" :have-loading="true" :loading="loadingEditInvoice"
                    :disabled="loadingEditInvoice"
                    @emit-click="editInvoice"/>
      </template>
    </modal-default>

    <page-header :headerName="'Historico de faturas'" :showBtn="false" :btnName="''" :btnRoute="''"
                 :css="'container-fluid'"/>

    <div class="page-content">
      <div class="container-fluid">
        <div class="row">
          <!-- Loading from page -->
          <full-loading v-if="loadingList"/>

          <!-- Filters -->
          <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12">
            <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="input-group input-with-date">
                    <label>Data Inicial</label>
                    <datepicker ref="programaticOpen3" v-model="dataSearch.init" :language="ptBR"
                                :format="customFormatter"/>
                    <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="input-group input-with-date">
                    <label>Data Final</label>
                    <datepicker ref="programaticOpen4" v-model="dataSearch.end" :language="ptBR"
                                :format="customFormatter"/>
                    <i v-on:click="openCalendar4()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="name">ID da empresa</label>
                    <input v-model="dataSearch.id" type="text" class="form-control" id="id" name="id">
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="name">Nome da empresa</label>
                    <input v-model="dataSearch.name" type="text" class="form-control" id="name" name="name">
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label for="name">E-mail da empresa ou financeiro</label>
                    <input v-model="dataSearch.email" type="text" class="form-control" id="email" name="email">
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group">
                    <label>Status</label>
                    <select v-model="dataSearch.status" id="duration" name="duration" required>
                      <option value="">Selecione</option>
                      <option value="0">Pendente</option>
                      <option value="1">Pago</option>
                      <option value="2">Cancelado</option>
                      <option value="3">Expirado</option>
                      <option value="4">Transação negada</option>
                      <option value="5">Devolveu</option>
                      <option value="7">Parcialmente pago</option>
                      <option value="6">Autorizada</option>
                      <option value="8">Em Protesto</option>
                      <option value="9">Estorno</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <button v-on:click="searchData()">Pesquisar</button>
              </div>
            </div>
          </div>

          <!-- Table -->
          <div v-if="!loadingList && isSearch && dataList.length" class="col-xs-12 col-sm-12 col-md-12">
            <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
              <div class="portlet-title">
                <div class="caption">
                  <span class="caption-subject font-blue bold uppercase">Quantidade total ({{ dataList.length }})</span>
                </div>
              </div>

              <div class="portlet-body contate-table offset-top-20">
                <div class="table-scrollable table-scrollable-borderless">
                  <table class="table table-hover table-light table-icon">
                    <thead>
                    <tr>
                      <th> EMPRESA</th>
                      <th> STATUS</th>
                      <th> CUSTO TOTAL</th>
                      <th> EXPIRA EM</th>
                      <th> AÇÕES</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(c, index) in dataList">
                      <td><a v-bind:href="'/detalhes-da-empresa/' + c.companyId + '/' + c.contextCode" target="_blank"
                             class="link">{{ c.name }}</a></td>
                      <td>{{ c.subscriptionPaymentHistoryStatusStr }}</td>
                      <td>R$ {{ c.totalCost }}</td>
                      <td>{{ c.expireAt | formatFullDate }}</td>
                      <td>
                        <a v-on:click="openDetail(c.id)" target="_blank" title="Visualizar" class="btn-to-view">
                          <i class="fa fa-eye" aria-hidden="true"></i> Visualizar
                        </a>
                        <a v-on:click="openEditInvoice(c)" target="_blank" title="Editar" class="btn-to-view">
                          <ion-icon name="create-outline"></ion-icon>
                          Editar
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import swal from 'sweetalert';

import {
  PAYMENT_HISTORIES_M_DETAIL,
  PAYMENT_HISTORIES_M, PUT_EDIT_INVOICES
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import moment from "moment";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from "vuejs-datepicker";
import modalSubscriptionDetail from "../../modals/modalSubscriptionDetail";
import {
  UTIL
} from "../../../../utils";
import ModalPassword from "../../modals/modalPassword.vue";
import ModalDefault from "../../components/modals/modalDefault.vue";
import InputSelect from "../../components/inputs/inputSelect.vue";
import InputText from "../../components/inputs/inputText.vue";
import BtnCustom from "../../components/buttons/btnCustom.vue";

export default {
  name: "invoiceHistory",
  components: {
    BtnCustom,
    InputText,
    InputSelect,
    ModalDefault,
    ModalPassword,
    modalSubscriptionDetail,
    topMenu,
    datepicker,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      callCheckRequest: '',
      loadingList: false,
      isSearch: false,
      ptBR: ptBR,
      context: null,
      dataSearch: {
        init: '',
        end: '',
        id: '',
        name: '',
        email: '',
        status: '',
        r: '',
        p: '',
      },
      dataList: [],
      loadingEditInvoice: false,
      invoiceGenerateError: false,
      validateError: '',
      dataSendInvoice: {
        companyId: '',
        id: '',
        invoiceGenerated: false,
        uri: '',
        rpSn: null
      },
      trueOrFalse: [
        {
          id: false,
          name: 'Não'
        },
        {
          id: true,
          name: 'Sim'
        }
      ]
    }
  },
  methods: {
    editInvoice() {
      this.invoiceGenerateError = false;

      if (this.dataSendInvoice.invoiceGenerated && !this.dataSendInvoice.uri) {
        return this.invoiceGenerateError = true;
      } else {
        if (this.dataSendInvoice.uri) {
          let regex = /^(http|https|Http|Https|rtsp|Rtsp):\/\//i;
          let validate = regex.test(this.dataSendInvoice.uri);
          if (!validate) {
            this.validateError = 'Preencha um link válido!';
            return this.invoiceGenerateError = true;
          }
        }
        this.loadingEditInvoice = true;
        let obj = this.dataSendInvoice;
        REQUEST_SERVICE.requestContext('PUT', PUT_EDIT_INVOICES, this.context, obj).then(response => {
          UTIL_SERVICE.console("RESULT", "PUT_EDIT_INVOICES");
          $('#editInvoice').modal('hide');
          swal("Sucesso!", "A fatura foi alterada com sucesso.", "success");
          this.loadingEditInvoice = false;
          this.context = null;
          obj = null;
          this.getList();
        }).catch(reason => {
          reason.response.data.erros.map((value, index) => {
            $('#editInvoice').modal('hide');
            this.loadingEditInvoice = false;
            this.context = null;
            obj = null;
            swal("Aviso", value.value, "error");
          });
        })
      }
    },
    validateEditInvoice(password) {
      if (password === 'NotasFinc2024') {
        $('#editInvoice').modal();
      } else {
        swal("Aviso", "Senha incorreta!", "error");
      }
    },
    openEditInvoice(value) {
      this.dataSendInvoice.companyId = value.companyId;
      this.dataSendInvoice.id = value.id;
      this.dataSendInvoice.invoiceGenerated = value.invoiceGenerated;
      this.dataSendInvoice.uri = value.bankSlipUri;
      this.context = value.contextCode;
      value.rpSn ? this.dataSendInvoice.rpSn = value.rpSn : '';

      $('#password-modal').modal();
    },
    cleanModal() {
      this.invoiceGenerateError = false;
      this.dataSendInvoice = {
        companyId: '',
        id: '',
        invoiceGenerated: false,
        uri: '',
        rpSn: ''
      }
    },
    openCalendar3: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    openCalendar4: function () {
      this.$refs.programaticOpen4.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    mountUrl() {
      let url = PAYMENT_HISTORIES_M;
      url += "?init=" + moment(this.dataSearch.init).format("YYYY-MM-DD");
      url += "&end=" + moment(this.dataSearch.end).format("YYYY-MM-DD");
      url += "&p=1";
      url += "&r=300";

      if (this.dataSearch.name)
        url += "&name=" + this.dataSearch.name;

      if (this.dataSearch.id)
        url += "&id=" + this.dataSearch.id;

      if (this.dataSearch.email)
        url += "&email=" + this.dataSearch.email;

      if (this.dataSearch.status)
        url += "&status=" + this.dataSearch.status;

      return url;
    },
    getList() {
      this.loadingList = true;
      this.failRequest = false;
      this.isSearch = true;
      REQUEST_SERVICE.get(this.mountUrl()).then((response) => {
        UTIL_SERVICE.console("RESULT PAYMENT_HISTORIES_M:", response.data);

        this.dataList = response.data.items;
        this.loadingList = false;
      }).catch((reason) => {
        this.loadingList = false;
        this.failRequest = true;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    openDetail(id) {
      this.callCheckRequest = {
        random: Math.floor(Math.random() * 500),
        id: id
      };

      $("#modalSubscriptionDetail").modal();
    },
    searchData() {
      this.getList();
    }
  },
  beforeMount() {
    if (UTIL.checkP(JSON.parse(window.localStorage.getItem('mamUserMasterInfo')).id) === false) {
      this.$router.push({
        path: '/'
      });
    } else {
      this.dataSearch.init = new Date(moment().subtract(5, 'days'));
      this.dataSearch.end = new Date(moment().subtract(0, 'days'));

      if (this.$route.params.companyId) {
        this.dataSearch.id = this.$route.params.companyId;
        this.getList();
      }
    }
  }
}
</script>

<style lang="scss">

.invoice-text {
  margin: 0;
  padding: 6px 12px;
  background: #eef2f7;
  border-radius: 4px !important;
  font-size: 16px;
  color: #3A424E;
  margin-bottom: 15px;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.input-with-date {
  width: 100%;
}

.vdp-datepicker {
  input {
    width: 100%;
  }
}

.btn-to-view {
  ion-icon {
    margin-bottom: -1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/invoiceHistory/invoiceHistory.vue